export default {
    ExpandedURL: 'لینک اصلی',
    NumberOfVisit: 'تعداد بازدید',
    NumberOfVisitMin: 'تعداد بازدید از',
    NumberOfVisitMax: 'تعداد بازدید تا',
    ShortenedURL: 'لینک کوتاه شده'
}